import {
	ADMIN_DETAILS_GET,
	ADMIN_DETAILS_GET_FAIL,
	ADMIN_DETAILS_SUCCESS,
	DELETE_USER_RESPONSE_SUCCESS,
	OTP_VERIFICATION,
	OTP_VERIFICATION_FAIL,
	OTP_VERIFICATION_SUCCESS,
	RESET_USER_ADD,
	RESET_USER_DELETE,
	RESET_USER_EDIT,
	RESET_USER_SUSPEND,
	RESET_VERIFICION_MSG,
	SUSPEND_USER_RESPONSE_SUCCESS,
	UPDATE_ADMIN_PASSWORD,
	UPDATE_ADMIN_PASSWORD_FAIL,
	UPDATE_ADMIN_PASSWORD_SUCCESS,
	USER_ADD_TRIGGER,
	USER_LOGIN_FAIL,
	USER_LOGIN_FAIL_TOKEN,
	USER_LOGIN_FAIL_ACCOUNT,
	USER_LOGIN_REQUEST,
	USER_LOGIN_SUCCESS,
	USER_LOGOUT,
	USER_REQUEST_ADD,
	USER_REQUEST_EDIT,
	USER_REQUEST_GET,
	USER_REQUEST_PUT,
	USER_REQUEST_SUSPEND,
	USER_RESPONSE_ADD_FAIL,
	USER_RESPONSE_ADD_SUCCESS,
	USER_RESPONSE_EDIT_FAIL,
	USER_RESPONSE_EDIT_SUCCESS,
	USER_RESPONSE_GET_FAIL,
	USER_RESPONSE_GET_SUCCESS,
	USER_RESPONSE_PUT_FAIL,
	USER_RESPONSE_SUSPEND_FAIL,
	USER_SELECTED,
	USER_SIGNUP_REQUEST,
	USER_SIGNUP_SUCCESS,
	USER_SIGNUP_FAIL,
	SIGNUP_VERIFY_REQUEST,
	SIGNUP_VERIFY_SUCCESS,
	SIGNUP_VERIFY_FAIL,
	ZTP_DETAILS_GET,
	ZTP_DETAILS_SUCCESS,
	ZTP_DETAILS_GET_FAIL,
	REGION_DETAILS_GET,
	REGION_DETAILS_GET_FAIL,
	REGION_DETAILS_SUCCESS,
	TENANT_REQUEST_GET,
	TENANT_RESPONSE_GET_SUCCESS,
	TENANT_RESPONSE_GET_FAIL,
	TENANT_REQUEST_PUT,
	TENANT_RESPONSE_PUT_FAIL,
	DELETE_TENANT_RESPONSE_SUCCESS,
	RESET_TENANT_DELETE,
	TENANT_REQUEST_ADD,
	TENANT_RESPONSE_ADD_FAIL,
	TENANT_RESPONSE_ADD_SUCCESS,
	RESET_TENANT_ADD,
	TENANT_DOWNLOAD_REQUEST,
	TENANT_DOWNLAOD_RESPONSE_ADD_FAIL,
	TENANT_DOWNLOAD_RESPONSE_ADD_SUCCESS,
	TENANT_REQUEST_EDIT,
	TENANT_RESPONSE_EDIT_SUCCESS,
	TENANT_RESPONSE_EDIT_FAIL,
	RESET_TENANT_EDIT,
	HOST_RESPONSE_GET_FAIL,
	HOST_RESPONSE_GET_SUCCESS,
	HOST_REQUEST_GET,
	NOTIFICATION_TENANT_SUCCESS,
	NOTIFICATION_TENANT_FAIL,
	RESET_NOTIFICATION_TENANT_STATE,
	NOTIFICATION_TENANT,
	USER_LOGOUT_REQUEST,
	EMAIL_VERIFY_REQUEST,
	EMAIL_VERIFY_SUCCESS,
	EMAIL_VERIFY_FAIL,
	EMAIL_VERIFY_RESET,
	OTP_VERIFY_REQUEST,
	OTP_VERIFY_SUCCESS,
	OTP_VERIFY_FAIL,
	OTP_VERIFY_RESET,
	SIGNUP_DATA,
	SIGNUP_RESET,
} from '../constants/userConstants';

/**
 * Reducer function for managing user login state.
 *
 * @param {object} state - Current state of the user login.
 * @param {object} action - Action object that contains information about the action type and payload.
 * @return {object} - New state after applying the action.
 */
export const userLoginReducer = (state = {}, action) => {
	switch (action.type) {
		case USER_LOGIN_REQUEST:
			return { loading: true, loginRequest: action.payload };
		case USER_LOGIN_SUCCESS:
			return { loading: false, userInfo: action.payload };
		case USER_LOGIN_FAIL_TOKEN:
			return { loading: false, error: action.payload };
		case USER_LOGIN_FAIL_ACCOUNT:
			return { loading: false, error: action.payload };	
		case USER_LOGIN_FAIL:
			return { loading: false, error: action.payload };
		case USER_LOGOUT:
			return { loading: false };
	
		case USER_SIGNUP_FAIL:
			return {};
		default:
			return state;
	}
};

// const initialState = {
//     userInfo: null,
//     logoutMessage: '',
//     // other state variables
// };

export const userLogoutReducer = (state = { showAlert : false,
	alertType : null , 
	alertMsg: "",
}, action) => {
    switch (action.type) {
		case USER_LOGOUT_REQUEST:
			return { ...state, loading: true };
		case USER_LOGOUT:
			return { loading: false, logoutMessage: action.payload };
        default:
            return state;
    }
};
export const emailVerifyReducer = (state = {}, action) => {
    switch (action.type) {
		case EMAIL_VERIFY_REQUEST:
			return { ...state, loading: true };
		case EMAIL_VERIFY_SUCCESS:
			return { loading: false, emailMessage: action.payload };
		case EMAIL_VERIFY_FAIL:
			return { loading: false, error: action.payload };
		case EMAIL_VERIFY_RESET:
			return {};
        default:
            return state;
    }
};
export const OtpVerifyReducer = (state = {}, action) => {
    switch (action.type) {
		case 	OTP_VERIFY_REQUEST:
			return { ...state, loading: true };
		case OTP_VERIFY_SUCCESS:
			return { loading: false, otpMessage: action.payload };
		case OTP_VERIFY_FAIL:
				return { loading: false, error: action.payload };
		case OTP_VERIFY_RESET:
			return {};
        default:
            return state;
    }
};

export const createTenantReducer = (state = {}, action) => {
	switch (action.type) {
		case USER_SIGNUP_REQUEST:
			return { loading: true, signupRequest: action.payload };
		case USER_SIGNUP_SUCCESS:
			return { loading: false, signupInfo: action.payload };
		case USER_SIGNUP_FAIL:
			return { loading: false, error: action.payload };
		case SIGNUP_VERIFY_REQUEST:
			return { loading: true, signupverifyRequest: action.payload };
		case SIGNUP_VERIFY_SUCCESS:
			return { loading: false, signupVerifyInfo: action.payload };
		case SIGNUP_VERIFY_FAIL:
			return { loading: false, error: action.payload };
		case ZTP_DETAILS_GET:
			return { ...state, loading: true, editError: null };
		case ZTP_DETAILS_SUCCESS:
			return { loading: false, adminDetails: action.payload };
		case ZTP_DETAILS_GET_FAIL:
			return { loading: false, error: action.payload };
		case REGION_DETAILS_GET:
			return { ...state, loading: true, editError: null };
		case REGION_DETAILS_SUCCESS:
			return { loading: false, adminDetails: action.payload };
		case REGION_DETAILS_GET_FAIL:
			return { loading: false, error: action.payload };
		case SIGNUP_RESET:
			return {};
		default:
			return state;
	}
};

export const tenantAddReducer = (
	state = {
		statusOnAdd: null,
		addError: null,
		addData: [],
		loading: false,
	},
	action
) => {
	switch (action.type) {
		case TENANT_REQUEST_ADD:
			return { ...state, loading: true, addError: null };
		case TENANT_RESPONSE_ADD_FAIL:
			return {
				...state,
				loading: false,
				addError: action.payload,
			};
		case TENANT_RESPONSE_ADD_SUCCESS:
			return {
				...state,
				loading: false,
				...action.payload,
			};
		case RESET_TENANT_ADD:
			return {
				...state,
				loading: false,
				statusOnAdd: null,
				addError: null,
				addData: [],
			};
		default:
			return state;
	}
};

export const tenantListReducer = (state = { users: {} }, action) => {
	switch (action.type) {
		case TENANT_REQUEST_GET:
			return {
				...state,
				loading: true,
			};
		case TENANT_RESPONSE_GET_SUCCESS:
			return {
				...state,
				loading: false,
				users: action.payload,
			};
		case TENANT_RESPONSE_GET_FAIL:
			return {
				...state,
				loading: false,
				error: action.payload,
			};
		default:
			return state;
	}
};

export const tenantDeleteReducer = (
	state = {
		statusOnDelete: null,
		deleteError: null,
		data: [],
		loading: false,
	},
	action
) => {
	switch (action.type) {
		case TENANT_REQUEST_PUT:
			return {
				...state,
				loading: true,
				deleteError: null,
			};
		case TENANT_RESPONSE_PUT_FAIL:
			return {
				...state,
				loading: false,
				deleteError: action.payload,
			};
		case DELETE_TENANT_RESPONSE_SUCCESS:
			return {
				...state,
				loading: false,
				...action.payload,
			};
		case RESET_TENANT_DELETE:
			return {
				...state,
				loading: false,
				statusOnDelete: null,
				deleteError: null,
				data: [],
			};
		default:
			return state;
	}
};
export const tenantDownloadReducer = (
	state = {
		successMessageOnAdd: null,
		addError: null,
		addData: [],
		loading: false,
	},
	action
) => {
	switch (action.type) {
		case TENANT_DOWNLOAD_REQUEST:
			return { ...state, loading: true, addError: null };
		case TENANT_DOWNLAOD_RESPONSE_ADD_FAIL:
			return {
				...state,
				loading: false,
				addError: action.payload,
			};
		case TENANT_DOWNLOAD_RESPONSE_ADD_SUCCESS:
			return {
				...state,
				loading: false,
				...action.payload,
			};
		default:
			return state;
	}
};

export const cnmsHostListReducer = (state = { users: {} }, action) => {
	switch (action.type) {
		case HOST_REQUEST_GET:
			return {
				...state,
				loading: true,
			};
		case HOST_RESPONSE_GET_SUCCESS:
			return {
				...state,
				loading: false,
				users: action.payload,
			};
		case HOST_RESPONSE_GET_FAIL:
			return {
				...state,
				loading: false,
				error: action.payload,
			};
		default:
			return state;
	}
};

export const tenantEditReducer = (
	state = {
		statusOnEdit: null,
		editError: null,
		editUserResponse: [],
		loading: false,
	},
	action
) => {
	switch (action.type) {
		case TENANT_REQUEST_EDIT:
			return { ...state, loading: true, editError: null };
		case TENANT_RESPONSE_EDIT_FAIL:
			return {
				...state,
				loading: false,
				editError: action.payload,
			};
		case TENANT_RESPONSE_EDIT_SUCCESS:
			return {
				...state,
				loading: false,
				...action.payload,
			};
		case RESET_TENANT_EDIT:
			return {
				...state,
				loading: false,
				statusOnEdit: null,
				editError: null,
				editUserResponse: [],
			};
		default:
			return state;
	}
};

export const tenantNotificationReducer = (
	state = {
		successMessageOnAdd: null,
		addError: null,
		addData: [],
		loading: false,
	},
	action
) => {
	switch (action.type) {
		case TENANT_REQUEST_ADD:
			return { ...state, loading: true, addError: null };
		case TENANT_RESPONSE_ADD_FAIL:
			return {
				...state,
				loading: false,
				addError: action.payload,
			};
		case TENANT_RESPONSE_ADD_SUCCESS:
			return {
				...state,
				loading: false,
				...action.payload,
			};
			default:
			return state;
	}
};
export const notificationTenantReducer = (
	state = { notificationSuccess: null, notificationError: null },
	action
) => {
	switch (action.type) {
		case NOTIFICATION_TENANT:
			return {
				...state,
				loading: true,
			};
		case NOTIFICATION_TENANT_SUCCESS:
			return {
				...state,
				loading: false,
				notificationSuccess: action.payload,
			};
		case NOTIFICATION_TENANT_FAIL:
			return {
				...state,
				loading: false,
				notificationError: action.payload,
			};
		case RESET_NOTIFICATION_TENANT_STATE:
			return {
				...state,
				loading: false,
				notificationError: null,
				notificationSuccess: null,
			};
		default:
			return state;
	}
};

export const userListReducer = (state = { users: {} }, action) => {
	switch (action.type) {
		case USER_REQUEST_GET:
			return {
				...state,
				loading: true,
			};
		case USER_RESPONSE_GET_SUCCESS:
			return {
				...state,
				loading: false,
				users: action.payload,
			};
		case USER_RESPONSE_GET_FAIL:
			return {
				...state,
				loading: false,
				error: action.payload,
			};
		default:
			return state;
	}
};

export const userReducer = (
	state = {
		userSelected: {},
	},
	action
) => {
	switch (action.type) {
		case USER_SELECTED:
			return {
				...state,
				userSelected: action.payload,
			};
		default:
			return state;
	}
};

export const userDeleteReducer = (
	state = {
		statusOnDelete: null,
		deleteError: null,
		data: [],
		loading: false,
	},
	action
) => {
	switch (action.type) {
		case USER_REQUEST_PUT:
			return {
				...state,
				loading: true,
				deleteError: null,
			};
		case USER_RESPONSE_PUT_FAIL:
			return {
				...state,
				loading: false,
				deleteError: action.payload,
			};
		case DELETE_USER_RESPONSE_SUCCESS:
			return {
				...state,
				loading: false,
				...action.payload,
			};
		case RESET_USER_DELETE:
			return {
				...state,
				loading: false,
				statusOnDelete: null,
				deleteError: null,
				data: [],
			};
		default:
			return state;
	}
};

export const userSuspendReducer = (
	state = {
		statusOnSuspend: null,
		suspendError: null,
		suspendData: [],
		loading: false,
	},
	action
) => {
	switch (action.type) {
		case USER_REQUEST_SUSPEND:
			return { ...state, loading: true, suspendError: null };
		case USER_RESPONSE_SUSPEND_FAIL:
			return {
				...state,
				loading: false,
				suspendError: action.payload,
			};
		case SUSPEND_USER_RESPONSE_SUCCESS:
			return {
				...state,
				loading: false,
				...action.payload,
			};
		case RESET_USER_SUSPEND:
			return {
				...state,
				loading: false,
				statusOnSuspend: null,
				suspendError: null,
				suspendData: [],
			};
		default:
			return state;
	}
};

export const userAddReducer = (
	state = {
		statusOnAdd: null,
		addError: null,
		addData: [],
		loading: false,
	},
	action
) => {
	switch (action.type) {
		case USER_REQUEST_ADD:
			return { ...state, loading: true, addError: null };
		case USER_RESPONSE_ADD_FAIL:
			return {
				...state,
				loading: false,
				addError: action.payload,
			};
		case USER_RESPONSE_ADD_SUCCESS:
			return {
				...state,
				loading: false,
				...action.payload,
			};
		case RESET_USER_ADD:
			return {
				...state,
				loading: false,
				statusOnAdd: null,
				addError: null,
				addData: [],
			};
		default:
			return state;
	}
};

export const userEditReducer = (
	state = {
		statusOnEdit: null,
		editError: null,
		editUserResponse: [],
		loading: false,
	},
	action
) => {
	switch (action.type) {
		case USER_REQUEST_EDIT:
			return { ...state, loading: true, editError: null };
		case USER_RESPONSE_EDIT_FAIL:
			return {
				...state,
				loading: false,
				editError: action.payload,
			};
		case USER_RESPONSE_EDIT_SUCCESS:
			return {
				...state,
				loading: false,
				...action.payload,
			};
		case RESET_USER_EDIT:
			return {
				...state,
				loading: false,
				statusOnEdit: null,
				editError: null,
				editUserResponse: [],
			};
		default:
			return state;
	}
};

export const adminDetailReducer = (state = { adminDetails: {} }, action) => {
	switch (action.type) {
		case ADMIN_DETAILS_GET:
			return { ...state, loading: true, editError: null };
		case ADMIN_DETAILS_SUCCESS:
			return { loading: false, adminDetails: action.payload };
		case ADMIN_DETAILS_GET_FAIL:
			return { loading: false, error: action.payload };
		// case USER_LOGOUT:
		// 	return {loading: false, error: action.payload};
		default:
			return state;
	}
};
export const changePasswordReducer = (
	state = { pwSuccessMsg: null, pwErrorMsg: null },
	action
) => {
	switch (action.type) {
		case UPDATE_ADMIN_PASSWORD:
			return {
				...state,
				loading: true,
				pwErrorMsg: null,
				pwSuccessMsg: null,
			};
		case UPDATE_ADMIN_PASSWORD_SUCCESS:
			return {
				loading: false,
				adminDetails: action.payload,
				pwSuccessMsg: action.successMessage,
			};
		case UPDATE_ADMIN_PASSWORD_FAIL:
			return {
				loading: false,
				pwSuccessMsg: null,
				pwErrorMsg: action.payload,
			};
		default:
			return state;
	}
};

export const otpVerificationReducer = (
	state = { verificationSuccessMsg: null, verificationFailMsg: null },
	action
) => {
	switch (action.type) {
		case OTP_VERIFICATION:
			return {
				...state,
				loading: true,
				verificationFailMsg: null,
				verificationSuccessMsg: null,
			};
		case OTP_VERIFICATION_SUCCESS:
			return {
				loading: false,
				adminDetails: action.payload,
				verificationSuccessMsg: action.verificationSuccessMsg,
				verificationFailMsg: null,
			};
		case OTP_VERIFICATION_FAIL:
			return {
				loading: false,
				verificationSuccessMsg: null,
				verificationFailMsg: action.payload,
			};
		case RESET_VERIFICION_MSG:
			return {
				verificationFailMsg: null,
				verificationSuccessMsg: null,
			};
		default:
			return state;
	}
};

export const userTriggerReducer = (state = { userAddTrigger: false }, action) => {
	console.log('---->>>>', action);
    switch (action.type) {
        case USER_ADD_TRIGGER:

            return {
                ...state,
                userAddTrigger: action.payload,
            };
        default:
            return state;
    }
};

export const signupDataReducer = (
	state = {
		signupData: {},
	},
	action
) => {
	switch (action.type) {
		case SIGNUP_DATA:
			return {
				...state,
				signupData: action.payload,
			};
		default:
			return state;
	}
};
